module.exports = __webpack_public_path__ + "df0563e3ffde7a225cdb3647b6df3480.png";